<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <div class="modal-body" style="text-align: justify">
        <slot></slot>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-primary" @click="goToRegister">
          Regístrese ahora
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Modal title",
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["closeHomeModal"],
  watch: {
    isVisible(newValue) {
      if (newValue) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeHomeModal");
    },
    goToRegister() {
      this.$router.push({ name: "register" });
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Asegúrate de que sea lo suficientemente alto */
}
.modal-content {
  background: white;
  border-radius: 5px;
  overflow: hidden;
  max-width: 40vw;
  width: 100%;
  max-height: 100vh;
  z-index: 4;
}
/* Media query para resoluciones de teléfono */
@media (max-width: 767.98px) {
  .modal-content {
    max-width: 85vw;
    max-height: 90vh;
  }
}

.modal-header,
.modal-footer {
  padding: 1rem;
}
.modal-body {
  padding: 1rem;
}
.btn-close {
  border: none;
  background: none;
  font-size: 1.5rem;
  cursor: pointer;
}
</style>
